import { render, staticRenderFns } from "./CompanyPeoplePage.vue?vue&type=template&id=15d2268e&"
import script from "./CompanyPeoplePage.vue?vue&type=script&lang=js&"
export * from "./CompanyPeoplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports